import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from '../network/Configurations';

const addProfileCategory = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.post(API_URL.ADD_PROFILE_CATEGORY, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const updateProfileCategory = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.UPDATE_PROFILE_CATEGORY, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const deleteProfileCategory = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.delete(API_URL.DELETE_PROFILE_CATEGORY, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getProfileCategoryById = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_PROFILE_CATEGORY, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getProfileCategoryList = (params = undefined): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_PROFILE_CATEGORY_LIST, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

export const ProfileCategoryService = {
    addProfileCategory, 
    updateProfileCategory,
    deleteProfileCategory,
    getProfileCategoryById,
    getProfileCategoryList
}